import { HistoryPage } from "./history-page";

export const historyRoutes = {
	path: "/history",
	component: () => <HistoryPage />,
};
